import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { FormInput } from "../../../../Shared/Form/Input/FormInput";
import { CanSaveProperty } from "./CanSaveProperty";
import { emptyIGEPStateContainer } from "./GEPState/emptyGEPStateContainer";
import { GoalEditorPanel } from "./GoalEditorPanel";
import { HandleValueChange } from "./HandleValueChange";

export function GetGEPInputBox(
    GEP: GoalEditorPanel,
    options: GEPInputBoxOptions
) {
    const propertyName = options.property.toString();
    let value = GEP.state.currentState[propertyName];

    return (
        <span>
            <FormInput
                id={`goal_${propertyName}`}
                label={options.alternateLabel ?? propertyName}
                width={options.width || "190px"}
                type={options.type}
                value={value}
                onChange={(event) =>
                    HandleValueChange(GEP, event.target.value, propertyName)
                }
                onClear={() =>
                    HandleValueChange(
                        GEP,
                        emptyIGEPStateContainer[propertyName],
                        propertyName
                    )
                }
                readonly={!CanSaveProperty(propertyName)}
                suggestions={options.suggestions}
                displayBlock={options.displayBlock ?? true}
            />
        </span>
    );
}

interface GEPInputBoxOptions {
    property: keyof IGoal;
    alternateLabel?: string;
    type: "text" | "number" | "date";
    width?: string;
    suggestions?: string[];
    displayBlock?: boolean;
}
